import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Compass, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function OfferingsSection() {
  return <section id="offerings" className="relative py-24 bg-gradient-to-b from-earth-900 to-night-900" data-id="element-89">
      <div className="absolute inset-0 bg-grain opacity-15 pointer-events-none mix-blend-overlay" data-id="element-90"></div>

      {/* Decorative Stars */}
      <div className="absolute top-20 left-10 opacity-40 pointer-events-none hidden lg:block" data-id="element-91">
        <RadiantStar size={32} delay={0.2} data-id="element-92" />
      </div>
      <div className="absolute bottom-20 right-10 opacity-40 pointer-events-none hidden lg:block" data-id="element-93">
        <RadiantStar size={40} delay={0.4} data-id="element-94" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-95">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-96">
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-4" data-id="element-97">
            Your Journey Continues
          </h2>
          <p className="text-gold-400 text-lg font-medium tracking-wide uppercase" data-id="element-98">
            Choose your path
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-99">
          {/* 1-on-1 Coaching */}
          <Card hover className="flex flex-col items-center text-center border-t-4 border-t-gold-400" data-id="element-100">
            <div className="w-16 h-16 rounded-full bg-gold-400/10 flex items-center justify-center mb-6 text-gold-400" data-id="element-101">
              <Compass size={32} strokeWidth={1.5} data-id="element-102" />
            </div>
            <h3 className="font-serif text-2xl text-cream-50 mb-2" data-id="element-103">
              1-on-1 Coaching
            </h3>
            <p className="text-gold-400 font-medium mb-6 italic" data-id="element-104">
              Reconnect with yourself.
            </p>
            <p className="text-cream-50/80 mb-8 flex-grow" data-id="element-105">
              Return to your inner compass and trust your intuition. In these
              personal sessions, online or in nature, we focus on your unique
              path to clarity and confidence.
            </p>
            <Button variant="outline" href="#contact" className="w-full" data-id="element-106">
              Start Your Journey
            </Button>
          </Card>

          {/* Group Journeys */}
          <Card hover className="flex flex-col items-center text-center border-t-4 border-t-gold-400" data-id="element-107">
            <div className="w-16 h-16 rounded-full bg-gold-400/10 flex items-center justify-center mb-6 text-gold-400" data-id="element-108">
              <Users size={32} strokeWidth={1.5} data-id="element-109" />
            </div>
            <h3 className="font-serif text-2xl text-cream-50 mb-2" data-id="element-110">
              Group Journeys
            </h3>
            <p className="text-gold-400 font-medium mb-6 italic" data-id="element-111">
              Reconnect with nature.
            </p>
            <p className="text-cream-50/80 mb-8 flex-grow" data-id="element-112">
              Be part of a warm, grounded community and rediscover clarity
              through shared experience outdoors during our transformative
              weekend retreats.
            </p>
            <Button variant="outline" href="#contact" className="w-full" data-id="element-113">
              Join the Group
            </Button>
          </Card>
        </div>
      </div>
    </section>;
}